import { STANDARD_DOCUMENT_TYPES } from "../../../../../@core/models/enums";

export enum STANDARD_DOCUMENT_STATUS {
    START = "Start",
    DRAFT = "Draft",
    WAITING_FOR_APPROVAL = "Waiting for Approval",
    APPROVED = "Approved",
    REJECTED = "Rejected",
    SUBMITTED_FOR_SIGNATURE = "Submitted for Signature",
    SIGNED = "Signed",
    DECLINED = "Declined",
    COMPLETED = "Completed",
    SUBMITTED_FOR_REVIEW = "Submitted for Review",
    UNDER_REVIEW = "Under Review",
    ON_HOLD = "On Hold",
    CONDITIONALLY_APPROVED = "Conditionally Approved",
    DECLINED_TO_SIGN = "Declined to Sign",
    ISSUED_FOR_INTERNAL_USE_ONLY = "Issued for Internal Use Only",
    IN_PROGRESS = "In Progress",
    UNDER_REVISION = "Under Revision",
    REVISED = "Revised",
    ACHIEVED = "Achieved",
    DISPUTED = "Disputed",
    OBSOLETE = "Obsolete",
    EXPIRED = "Expired",
    TERMINATED = "Terminated",
    ISSUED_FOR_CONSTRUCTION_IFC = "Issued for Construction (IFC)",
    ISSUED_FOR_INFORMATION = "Issued for Information",
    ISSUED = "Issued",
    ACTIVE = "Active",
    PENDING_RESPONSE = "Pending Response",
    REJECTED_WITH_COMMENTS = "Rejected with Comments",
    EFFECTIVE = "Effective",
    ARCHIVED = "Archived",
    ISSUED_FOR_USE = "Issued for Use"
};



export const standardDocumentStatusMappings: { [key: string]: STANDARD_DOCUMENT_STATUS[] } = {
    'GENERIC': [
        STANDARD_DOCUMENT_STATUS.START, STANDARD_DOCUMENT_STATUS.DRAFT, STANDARD_DOCUMENT_STATUS.WAITING_FOR_APPROVAL,
        STANDARD_DOCUMENT_STATUS.APPROVED, STANDARD_DOCUMENT_STATUS.REJECTED, STANDARD_DOCUMENT_STATUS.SUBMITTED_FOR_SIGNATURE,
        STANDARD_DOCUMENT_STATUS.SIGNED, STANDARD_DOCUMENT_STATUS.DECLINED, STANDARD_DOCUMENT_STATUS.COMPLETED
    ],
    [STANDARD_DOCUMENT_TYPES.CONTRACT]: [
        STANDARD_DOCUMENT_STATUS.START, STANDARD_DOCUMENT_STATUS.DRAFT, STANDARD_DOCUMENT_STATUS.SUBMITTED_FOR_REVIEW,
        STANDARD_DOCUMENT_STATUS.UNDER_REVIEW, STANDARD_DOCUMENT_STATUS.ON_HOLD, STANDARD_DOCUMENT_STATUS.APPROVED,
        STANDARD_DOCUMENT_STATUS.CONDITIONALLY_APPROVED, STANDARD_DOCUMENT_STATUS.REJECTED, STANDARD_DOCUMENT_STATUS.SUBMITTED_FOR_SIGNATURE,
        STANDARD_DOCUMENT_STATUS.SIGNED, STANDARD_DOCUMENT_STATUS.DECLINED_TO_SIGN, STANDARD_DOCUMENT_STATUS.ISSUED_FOR_INTERNAL_USE_ONLY,
        STANDARD_DOCUMENT_STATUS.IN_PROGRESS, STANDARD_DOCUMENT_STATUS.UNDER_REVISION, STANDARD_DOCUMENT_STATUS.REVISED,
        STANDARD_DOCUMENT_STATUS.ARCHIVED, STANDARD_DOCUMENT_STATUS.DISPUTED, STANDARD_DOCUMENT_STATUS.OBSOLETE,
        STANDARD_DOCUMENT_STATUS.EXPIRED, STANDARD_DOCUMENT_STATUS.TERMINATED, STANDARD_DOCUMENT_STATUS.COMPLETED
    ],
    [STANDARD_DOCUMENT_TYPES.SPECIFICATION]: [
        STANDARD_DOCUMENT_STATUS.START, STANDARD_DOCUMENT_STATUS.DRAFT, STANDARD_DOCUMENT_STATUS.SUBMITTED_FOR_REVIEW,
        STANDARD_DOCUMENT_STATUS.UNDER_REVIEW, STANDARD_DOCUMENT_STATUS.ON_HOLD, STANDARD_DOCUMENT_STATUS.APPROVED,
        STANDARD_DOCUMENT_STATUS.CONDITIONALLY_APPROVED, STANDARD_DOCUMENT_STATUS.REJECTED, STANDARD_DOCUMENT_STATUS.SUBMITTED_FOR_SIGNATURE,
        STANDARD_DOCUMENT_STATUS.SIGNED, STANDARD_DOCUMENT_STATUS.DECLINED_TO_SIGN, STANDARD_DOCUMENT_STATUS.ISSUED_FOR_CONSTRUCTION_IFC,
        STANDARD_DOCUMENT_STATUS.ISSUED_FOR_INTERNAL_USE_ONLY, STANDARD_DOCUMENT_STATUS.ISSUED_FOR_INFORMATION, STANDARD_DOCUMENT_STATUS.IN_PROGRESS,
        STANDARD_DOCUMENT_STATUS.UNDER_REVISION, STANDARD_DOCUMENT_STATUS.REVISED, STANDARD_DOCUMENT_STATUS.ARCHIVED,
        STANDARD_DOCUMENT_STATUS.DISPUTED, STANDARD_DOCUMENT_STATUS.OBSOLETE, STANDARD_DOCUMENT_STATUS.EXPIRED,
        STANDARD_DOCUMENT_STATUS.COMPLETED
    ],
    [STANDARD_DOCUMENT_TYPES.SAFETY_DOCUMENT]: [
        STANDARD_DOCUMENT_STATUS.START, STANDARD_DOCUMENT_STATUS.DRAFT, STANDARD_DOCUMENT_STATUS.SUBMITTED_FOR_REVIEW,
        STANDARD_DOCUMENT_STATUS.UNDER_REVIEW, STANDARD_DOCUMENT_STATUS.ON_HOLD, STANDARD_DOCUMENT_STATUS.APPROVED,
        STANDARD_DOCUMENT_STATUS.CONDITIONALLY_APPROVED, STANDARD_DOCUMENT_STATUS.REJECTED, STANDARD_DOCUMENT_STATUS.SUBMITTED_FOR_SIGNATURE,
        STANDARD_DOCUMENT_STATUS.SIGNED, STANDARD_DOCUMENT_STATUS.DECLINED_TO_SIGN, STANDARD_DOCUMENT_STATUS.ISSUED_FOR_USE,
        STANDARD_DOCUMENT_STATUS.ISSUED_FOR_INTERNAL_USE_ONLY, STANDARD_DOCUMENT_STATUS.ISSUED_FOR_INFORMATION, STANDARD_DOCUMENT_STATUS.IN_PROGRESS,
        STANDARD_DOCUMENT_STATUS.UNDER_REVISION, STANDARD_DOCUMENT_STATUS.REVISED, STANDARD_DOCUMENT_STATUS.ARCHIVED,
        STANDARD_DOCUMENT_STATUS.DISPUTED, STANDARD_DOCUMENT_STATUS.OBSOLETE, STANDARD_DOCUMENT_STATUS.EXPIRED,
        STANDARD_DOCUMENT_STATUS.TERMINATED, STANDARD_DOCUMENT_STATUS.COMPLETED
    ],
    [STANDARD_DOCUMENT_TYPES.NOTICE]: [
        STANDARD_DOCUMENT_STATUS.START, STANDARD_DOCUMENT_STATUS.DRAFT, STANDARD_DOCUMENT_STATUS.SUBMITTED_FOR_REVIEW,
        STANDARD_DOCUMENT_STATUS.UNDER_REVIEW, STANDARD_DOCUMENT_STATUS.ON_HOLD, STANDARD_DOCUMENT_STATUS.APPROVED,
        STANDARD_DOCUMENT_STATUS.CONDITIONALLY_APPROVED, STANDARD_DOCUMENT_STATUS.REJECTED, STANDARD_DOCUMENT_STATUS.SUBMITTED_FOR_SIGNATURE,
        STANDARD_DOCUMENT_STATUS.SIGNED, STANDARD_DOCUMENT_STATUS.DECLINED_TO_SIGN, STANDARD_DOCUMENT_STATUS.ISSUED,
        STANDARD_DOCUMENT_STATUS.ISSUED_FOR_INTERNAL_USE_ONLY, STANDARD_DOCUMENT_STATUS.ISSUED_FOR_INFORMATION, STANDARD_DOCUMENT_STATUS.EFFECTIVE,
        STANDARD_DOCUMENT_STATUS.UNDER_REVISION, STANDARD_DOCUMENT_STATUS.REVISED, STANDARD_DOCUMENT_STATUS.ARCHIVED,
        STANDARD_DOCUMENT_STATUS.DISPUTED, STANDARD_DOCUMENT_STATUS.OBSOLETE, STANDARD_DOCUMENT_STATUS.TERMINATED,
        STANDARD_DOCUMENT_STATUS.EXPIRED, STANDARD_DOCUMENT_STATUS.COMPLETED
    ],
    [STANDARD_DOCUMENT_TYPES.QUESTIONNAIRE]: [
        STANDARD_DOCUMENT_STATUS.START, STANDARD_DOCUMENT_STATUS.ISSUED, STANDARD_DOCUMENT_STATUS.ACTIVE,
        STANDARD_DOCUMENT_STATUS.PENDING_RESPONSE, STANDARD_DOCUMENT_STATUS.ON_HOLD, STANDARD_DOCUMENT_STATUS.APPROVED,
        STANDARD_DOCUMENT_STATUS.REJECTED, STANDARD_DOCUMENT_STATUS.REJECTED_WITH_COMMENTS, STANDARD_DOCUMENT_STATUS.SUBMITTED_FOR_SIGNATURE,
        STANDARD_DOCUMENT_STATUS.SIGNED, STANDARD_DOCUMENT_STATUS.DECLINED_TO_SIGN, STANDARD_DOCUMENT_STATUS.UNDER_REVISION,
        STANDARD_DOCUMENT_STATUS.REVISED, STANDARD_DOCUMENT_STATUS.ARCHIVED, STANDARD_DOCUMENT_STATUS.EXPIRED,
        STANDARD_DOCUMENT_STATUS.OBSOLETE, STANDARD_DOCUMENT_STATUS.TERMINATED, STANDARD_DOCUMENT_STATUS.COMPLETED
    ]
}
